import { render, staticRenderFns } from "./just.vue?vue&type=template&id=0a6380b4&scoped=true&"
import script from "./just.vue?vue&type=script&lang=js&"
export * from "./just.vue?vue&type=script&lang=js&"
import style0 from "./just.vue?vue&type=style&index=0&id=0a6380b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6380b4",
  null
  
)

export default component.exports